<template>
  <div style="display: flex;">
    <el-row>
      <el-col :span="2">
        <div v-if="tabType !==''" class="text-start" style="padding: 7px 0;margin-top: 5px;">{{ tabType }}</div>
      </el-col>
      <el-col :span="22">
        <!--        <div style="width: 100%;">-->
        <div class="tabs-box" style="display: flex;flex-wrap: wrap;" :class="isBorder==true?'tabs-border':''">
          <div v-for="(item,i) in tabsList" style="margin: 5px 0;" class="tabs"
               :class="{'buxian-margin':i==0,'tabs-active':active==i}"
               @click="activeHandle(item,i)" :key="i">
            <span style="text-align: center;">{{ item.value }}</span>
            <span v-if="tabType == '排序' && i == active && i != 0">
                <i :class="sort ? 'el-icon-top' : 'el-icon-bottom'"></i>
              </span>
          </div>
        </div>
        <!--        </div>-->
      </el-col>
    </el-row>

    <div v-if="tabType == '厂商'" style="margin-top: 18px;font-size: .14rem;padding-left: 35px;">更多</div>
  </div>
</template>

<script>
export default {
  props: {
    tabsList: {
      type: Array
    },
    isBorder: {
      type: Boolean,
      default: true
    },
    tabType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      active: -1,
      sort: true,
      value: '',
      list: ''
    };
  },
  methods: {
    activeHandle(item, i) {
      //判断箭头
      if (i == this.active) {
        this.sort = !this.sort
      } else {
        this.sort = true
      }
      this.active = i

      this.$emit('active', item.key, this.sort ? 1 : 2)
    },
    handleTabClick(value) {
      this.$nextTick(() => {
        // 从 tabsList 中找到 key 与 item.key 相等的那个对象
        const matchedItem = this.tabsList.find(tab => tab.key == value)
        if (matchedItem) {
          this.active = this.tabsList.indexOf(matchedItem) // 或者直接用 findIndex 拿索引
          this.$emit('active', matchedItem.key, this.sort ? 1 : 2)
        }
      })
      }
    }
  }
</script>

<style sxoped>
.tabs-box {
  width: 1130px;
  max-height: 155px;
}

.text-start {
  width: .96rem;
  font-size: .14rem;
  font-family: PingFang SC-Regular, PingFang SC;
  color: #8F8F8F;
  line-height: .20rem;
}

.tabs {

  padding: .06rem .10rem;
  border-radius: .06rem;
  font-size: .14rem;
  font-family: PingFang SC-Regular, PingFang SC;
  color: #333333;
  line-height: .20rem;
  margin-right: .15rem;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  show-overflow-tooltip: initial

}

.buxian-margin {
  margin-right: .11rem;
}

.tabs-active {
  background: #FF7D34;
  color: #FFFFFF;
}

.tabs-border {
  border-bottom: .01rem dashed #EDEDED;
}
</style>
